import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { HqTemplateComponent } from './hq-template/hq-template.component';
import { SharedModule } from '../shared/shared.module';
import { ConfirmDeactivateGuard } from './candeactivate.guard';
import { OverviewComponent } from './overview/overview.component';
import { CartService } from '../store/cart/cart.service';
import { OverviewService } from './overview/overview.service';
import { ManageMaterialsModule } from './materials/manage-materials.module';
import { ManageMaterialsComponent } from './materials/manage-materials.component';
import { CardModule } from './cards/card.module';
import { ViewCardsComponent } from './cards/view-cards/view-cards/view-cards.component';
import { HqGuard } from '../shared/auth/hq.guard';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild([
        { path: '',
          component: HqTemplateComponent,
          canActivate: [HqGuard],
          children: [
            { path: '', pathMatch: 'full', redirectTo: 'overview' },
            { path: 'overview', component: OverviewComponent },
            { path: 'materials', component: ManageMaterialsComponent },
            { path: 'view-cards/:id', component: ViewCardsComponent, canDeactivate: [ConfirmDeactivateGuard] },
          ]
        },
    ]),
    ManageMaterialsModule,
    CardModule
  ],
  providers: [CartService, OverviewService, ConfirmDeactivateGuard],
  declarations: [HqTemplateComponent, OverviewComponent]
})
export class HqModule { }



// WEBPACK FOOTER //
// /app/src/app/hq/hq.module.ts